import React, {Component} from 'react'
import Geosuggest from 'react-geosuggest'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'

class GeosuggestComponent extends Component {
  static displayName = 'GeosuggestComponent'

  componentDidMount() {
    const {autoFocus, autoFocusDelay} = this.props

    if (autoFocus) {
      setTimeout(() => {
        this.geoSuggest.focus()
      }, autoFocusDelay)
    }
  }

  render() {
    const {
      input,
      label,
      meta,
      placeholder,
      handleSelect,
      autoComplete,
      getSuggestLabel,
      renderSuggestItem,
      skipSuggest,
      onKeyDown,
      warning
    } = this.props

    return (
      <FormField status={meta} label={label} error={meta.error} value={input.value} warning={warning}>
        <Geosuggest
          ref={el => this.geoSuggest = el}
          inputClassName="InspectletIgnore"
          autoComplete={autoComplete}
          onSuggestSelect={handleSelect}
          placeholder={placeholder}
          country="us"
          autoActivateFirstSuggest={true}
          initialValue={input.value}
          onKeyDown={onKeyDown}
          skipSuggest={skipSuggest}
          getSuggestLabel={getSuggestLabel}
          renderSuggestItem={renderSuggestItem}
          {...input}
        />
        <Label>{label}</Label>
      </FormField>
    )
  }
}

export {GeosuggestComponent}
